import styled, { css } from 'styled-components'

import FormFieldSelect from '../../form/fields/FormFieldSelect'
import ActionButton from '../ActionButton'
import { mq, sizes } from '../../theme'
import AdsSearchForm from '../../forms/AdsSearchForm'

export enum AdsSortingFiltersVariant {
  primary = 'primary',
  secondary = 'secondary',
}

export const Wrapper = styled.div``

export const SearchLabel = styled.p`
  ${({ theme }) => theme.textStyles.firaSans3Xl};
  color: ${({ theme }) => theme.colors.bluePrimary};

  @media ${mq(null, sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSansXl};
  }
`

export const TermValue = styled.span`
  ${({ theme }) => theme.textStyles.firaSans3Xl};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-left: 0.5rem;

  @media ${mq(null, sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSansXl};
  }
`

export const SearchFieldValueList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
`

export const SearchFieldValueListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;
  border-radius: 2rem;
  border: 1px solid ${({ theme }) => theme.colors.greyContour};
  background: ${({ theme }) => theme.colors.brownBack};
  padding: 0.8rem 2rem;
  width: max-content;
  color: ${({ theme }) => theme.colors.greyContour};
  ${({ theme }) => theme.textStyles.montserratTextBase};
`

export const SearchResults = styled.p`
  ${({ theme }) => theme.textStyles.vujahdayLarge};
  color: ${({ theme }) => theme.colors.bluePrimary};
  font-style: italic;
`

export const Search = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  flex: 1;
`

export const Middle = styled.div<{
  $variant?: AdsSortingFiltersVariant
  $isOpen: boolean
}>`
  background-color: ${({ theme, $variant }) =>
    !$variant || $variant === AdsSortingFiltersVariant.primary
      ? theme.colors.pureWhite
      : theme.colors.blueBack};

  padding: 3.5rem;
  margin: 0 -2rem;

  @media ${mq(sizes.desktop)} {
    padding: 5rem 10.5rem;
  }

  display: none;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      display: block;
    `}
`

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  margin: 0 0 2rem 0;
`

export const SearchForm = styled(AdsSearchForm)``

export const DisplaySelectField = styled(FormFieldSelect)`
  > label {
    border-color: ${({ theme }) => theme.colors.bluePrimary};
  }

  select,
  svg {
    color: ${({ theme }) => theme.colors.bluePrimary};
  }

  width: 100%;

  @media ${mq(sizes.tablet)} {
    display: none;
  }
`

export const DisplaySwitch = styled.div`
  display: none;

  @media ${mq(sizes.tablet)} {
    display: flex;
    gap: 0.8rem;
  }
`

export const DisplaySwitchButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  padding: 0;
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.bluePrimary : theme.colors.hopbush};
  border-radius: 1rem;
  background-color: ${({ theme, $active }) =>
    $active ? theme.colors.bluePrimary : 'transparent'};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.pureWhite : theme.colors.bluePrimary};
  cursor: pointer;
`

export const OrderSelectField = styled(FormFieldSelect)`
  width: 24rem;

  @media ${mq(null, sizes.tablet)} {
    width: 100%;
  }
`
export const FilterButton = styled(ActionButton)``
export const AlertCreationButton = styled(ActionButton)``

export const Top = styled.div`
  display: flex;
  gap: 1.8rem;
  align-items: baseline;
  justify-content: space-between;
  margin: 4rem auto;

  @media ${mq(null, sizes.tablet)} {
    flex-direction: column;
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 2.6rem;
  width: 100%;
  flex: 1;

  @media ${mq(sizes.tablet)} {
    justify-content: flex-end;
  }
`

export const Bottom = styled.div`
  margin-top: 4rem;
  display: flex;
  flex-direction: column-reverse;
  gap: 2rem;

  @media ${mq(sizes.tablet)} {
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
`

export const SortResult = styled.p`
  ${({ theme }) => theme.textStyles.vujahdayMedium};
  color: ${({ theme }) => theme.colors.bluePrimary};
`

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media ${mq(sizes.tablet)} {
    flex-direction: row;
  }
`
